import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

export default class CardFormDespesa extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {}
        }

    }

    render() {
        let { unidade, metas, titulo, subtitulo } = this.props;
        let meses = ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa/ZEUS"];
        let name = ["numeroAtendimento", "horasTecnicas", "receita", "despesa"];
        return (
            <Fragment>
            <div className="content">
                <div className="row pr-3 pl-3">
                    <div className="col-md-12 ml-auto mr-auto">
                        <div className="card card-user">
                            <div className="card-header">
                                <h5 className="card-title">{titulo || "Geral Total"} | {subtitulo || "Soluções em Tecnologia e Inovação - STI"}</h5>
                                <div className="row justify-content-end">
                                    <Link to={location => (
                                        { 
                                            ...location, 
                                            pathname: `/sti/${this.props.unidade.toLowerCase()}`, 
                                            anterior: window.location.pathname || "/unidade", 
                                            unidade: this.props.unidade 
                                        }
                                        )}>
                                        <button className="btn" style={{float: "right"}}>Despesas</button>
                                    </Link>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        
                                        {this.props.children[0]}
                                        <hr />

                                        <div className="table table-striped table-hover table-borderless table-sm">
                                            <form onSubmit={this.props.onSubmit} className="gap" id="cadastrocursoooo">
                                                {this.props.children[1]}
                                                <div className="row">
                                                    <div className="update ml-auto mr-auto">
                                                        <button type="submit" className="btn btn-primary btn-round">Cadastrar</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </Fragment>
        )
    }
}